import React from "react";
import "../assets/css/vasiGradientPanel.css";

export default function VasiGradientPanel({ children, className = "" }) {
  return (
    <section className={`vasi-gradpanel ${className}`}>
      <div className="vasi-gradpanel__inner">{children}</div>
    </section>
  );
}
